import React from 'react';
import './Awards.css';
import winnerImg from '../assets/winner.png';
import starImg from '../assets/star.png';
import badgeImg from '../assets/badge.png';

const Awards = () => {
  return (
    <>
      <div className="awards-section">
        <div className="awards-container">
          <div className="awards-line">
            <h2 className="awards-title">
              <img src={winnerImg} alt="Award" className="award-icon" style={{ width: '40px', height: '40px' }} />
              <span className="awards-text">Award-Winning Care</span>
            </h2>
            <div className="award-categories  award-years-inline">
              <span>
                <img src={winnerImg} alt="Award" className="award-category-icon" style={{ width: '25px', height: '25px', marginRight: '8px' }} />
                Best Medical Clinic
              </span>
              <span>
                <img src={starImg} alt="Star" className="award-category-icon" style={{ width: '18px', height: '18px', marginRight: '8px' }} />
                Best Customer Service
              </span>
              <span>
                <img src={badgeImg} alt="Badge" className="award-category-icon" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                Best Provider
              </span>
            </div>
            <div className="award-years-inline award-years">
              <span>2020</span>
              <span>2022</span>
              <span>2023</span>
              <span>2024</span>
            </div>
            <div className="favorite-provider">
              <div>2025</div>
              <div>Favorite Provider</div>
            </div>
          </div>
        </div>
        <div className="award-source">
            <p>Elko Daily Free Press Readers Choice Awards</p>
        </div>
      </div>

      <section className="primary-care-notice">
        <div className="primary-care-notice-container">
          <p>Effective <strong>May 4, 2026</strong>, Aspen Quick Care will no longer provide <strong>Primary Care services</strong>. This change is being made in an effort to reduce wait times and streamline services within our clinics. Aspen Quick Care will continue to offer Urgent Care services, providing same-day care for non-life-threatening illnesses and injuries to support the needs of our community.</p>
        </div>
      </section>
    </>
  );
};

export default Awards;
